import { CalendarEventTypeEnum, PrivacyEnum, type CalendarEvent } from '@/types/generated'

export const CALENDAR_EVENT_TYPE_ORDER: CalendarEventTypeEnum[] = [
  CalendarEventTypeEnum.TERMIN,
  CalendarEventTypeEnum.GERICHTSTERMIN,
  CalendarEventTypeEnum.FRIST,
  CalendarEventTypeEnum.WIEDERVORLAGE,
  CalendarEventTypeEnum.AUFGABE,
  CalendarEventTypeEnum.PRIVAT
]

export function resolveCalendarEventType(
  event: Pick<CalendarEvent, 'type' | 'privacy'>
): CalendarEventTypeEnum {
  if (event.privacy === PrivacyEnum.PRIVAT) {
    return CalendarEventTypeEnum.PRIVAT
  }

  return event.type ?? CalendarEventTypeEnum.TERMIN
}

export function composerModeForEvent(event: Pick<CalendarEvent, 'type'>): CalendarEventTypeEnum {
  if (
    event.type === CalendarEventTypeEnum.FRIST ||
    event.type === CalendarEventTypeEnum.WIEDERVORLAGE ||
    event.type === CalendarEventTypeEnum.AUFGABE
  ) {
    return event.type
  }

  return CalendarEventTypeEnum.TERMIN
}
